<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-passport'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isStatusEmpty"><span class="font-weight-bold" v-if="!isNumberEmpty">番号：</span>{{ printNumber }}</v-list-item-subtitle>
      <v-list-item-title>{{ printStatus }}</v-list-item-title>
      <v-list-item-subtitle class="caption" v-if="!isTermEmpty">
        <span class="font-weight-bold">有効期間：</span>{{ printTerm }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.status"
          :rules="rules.status"
          @change="changed">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes">
        <v-text-field
          v-model="form.number"
          label="旅券番号"
          mask="AA#######"
          :rules="rules.number"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.publish"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedPublish"
              v-on="on"
              :rules="rules.publish"
              label="発行日"
            />
          </template>
          <v-date-picker
            v-model="form.publish"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.publish = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.expire"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedExpire"
              v-on="on"
              :rules="rules.expire"
              label="失効日"
            />
          </template>
          <v-date-picker
            v-model="form.expire"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.expire = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsPassport',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'passport',
        datepicker: {
          publish: false,
          expire: false
        }
      },
      meta: {
        status: {
          YES: '所持',
          PROGRESS: '申請中',
          NO: '未所持'
        }
      },
      form: {
        id: '',
        status: '',
        number: '',
        publish: '',
        expire: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        number: [
          v => !!v || '必須項目です'
        ],
        publish: [
          v => !!v || '必須項目です'
        ],
        expire: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          number: dt.number ? dt.number : '',
          publish: dt.publish ? dt.publish : '',
          expire: dt.expire ? dt.expire : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          number: this.$props.data.number ? this.$props.data.number : '',
          publish: this.$props.data.publish ? this.$props.data.publish : '',
          expire: this.$props.data.expire ? this.$props.data.expire : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('passport_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    changed: function () {
      this.prepare({
        id: '' + (this.$props.data.id ? this.$props.data.id : ''),
        status: this.form.status ? this.form.status : ''
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('passport_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('passport_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('passport_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$mango.about.passport.status[this.$props.data.status]
      ) ? this.$mango.about.passport.status[this.$props.data.status] : 'パスポートの回答'
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    printNumber () {
      return (
        this.$props.data &&
        this.$props.data.number
      ) ? this.$props.data.number : ''
    },
    printTerm () {
      return (
        this.$props.data
      ) ? [
          this.$props.data.publish ? this.$moment(this.$props.data.publish).format('YYYY/MM/DD') : '',
          this.$props.data.expire ? this.$moment(this.$props.data.expire).format('YYYY/MM/DD') : ''
        ].join('〜') : ''
    },
    printFormatedPublish () {
      return (
        this.form &&
        this.form.publish
      ) ? this.$moment(this.form.publish).format('YYYY/MM/DD') : ''
    },
    printFormatedExpire () {
      return (
        this.form &&
        this.form.expire
      ) ? this.$moment(this.form.expire).format('YYYY/MM/DD') : ''
    },
    isStatusEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.status
      )
    },
    isNumberEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.number
      )
    },
    isTermEmpty () {
      return !(
        this.$props.data &&
        [
          this.$props.data.publish ? this.$props.data.publish : '',
          this.$props.data.expire ? this.$props.data.expire : ''
        ].join('')
      )
    },
    getStatusItems () {
      return this.$mango.about.passport.status
    }
  }
}
</script>
